<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mt-3">
            <v-autocomplete hide-details="auto" :items="search_data_list" @change="searchFood" item-text="name" item-value="id" color="primary" label="ค้นหาเมนูเครื่องดื่ม" prepend-inner-icon="mdi-magnify" dense outlined></v-autocomplete>
        </div>
        <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel v-for="(menu,key) in data" :key="key" class="mt-2">
                <v-expansion-panel-header class="color_font_drink">
                    <div>{{ menu.name }}</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="body_drink">
                    <v-row>
                        <v-col cols="6" sm="3" md="3" lg="3" xl="3" v-for="(detail,key_food) in menu.menuList" :key="key_food">
                            <div class="cursor_drink" @click="getDetail(detail.id)" v-if="detail.status == 1">
                                <div class="img_food_pos_table_detail">
                                    <img :src="detail.path">
                                </div>
                                <div class="text-center">{{ detail.name }}</div>
                            </div>
                            <div class="cursor_drink" v-if="detail.status == 0">
                                <div class="img_food_pos_table_detail">
                                    <img :src="detail.path">
                                    <div class="img_sole_pos_table_detail">
                                        <img src="@/assets/soulout.png">
                                    </div>
                                </div>
                                <div class="text-center">{{ detail.name }}</div>
                            </div>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>


    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    data() {
        return {
            loading_page: true,
            search_data_list:[],
            panel:[0],
            data: []
        }
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    methods: {
        async getDrinkList() {
            this.loading_page = true
            HTTP.get('/POS/table/open-drink-menu-list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.data = response.data.listDrink
                        this.data.forEach((detail_menu) => {
                            detail_menu.menuList.forEach((detail) => {
                                let food_name = detail.name
                                if (detail.state == 0) {
                                    food_name = detail.name+' (สินค้าหมด)'
                                }
                                this.search_data_list.push({
                                    id:detail.id,
                                    name:food_name,
                                    status:detail.status,
                                })
                            })
                        })
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

        },
        async searchFood(id){
            let data_food_detail =  this.search_data_list.find((detail) =>{ return detail.id == id })
            if (data_food_detail.status == 1) {
                this.getDetail(id)
            }
        },
        async getDetail(id) {
            const dataList = {
                id:id,
                type:null
            }
            this.$emit('eventGetDetail', dataList)
        }
    },
    mounted() {
        this.getDrinkList()
    }
}
</script>

<style scoped>
.cursor_drink{
    cursor: pointer;
}

.color_font_drink {
    border: 1px #038cc1 solid;
}

.color_font_drink>div {
    font-size: 20px;
}

.color_font_drink>div>span,
.color_font_drink>>>i {
    color: #038cc1 !important;
}

.body_drink>>>.v-expansion-panel-content__wrap {
    padding: 15px;
}
</style>
